"use strict";

module.exports = {
    "VIDEO": "Video",
    "SOURCE": "Source",
    "MEDIA": "Media",
    "AUDIO": "Audio",
    "UL": "UL",
    "TRACK": "Track",
    "TITLE": "Title",
    "TEXTAREA": "TextArea",
    "TEMPLATE": "Template",
    "TBODY": "TBody",
    "THEAD": "THead",
    "TFOOT": "TFoot",
    "TR": "TR",
    "TABLE": "Table",
    "COL": "Col",
    "COLGROUP": "ColGroup",
    "TH": "TH",
    "TD": "TD",
    "CAPTION": "Caption",
    "STYLE": "Style",
    "SPAN": "Span",
    "SHADOW": "Shadow",
    "SELECT": "Select",
    "SCRIPT": "Script",
    "QUOTE": "Quote",
    "PROGRESS": "Progress",
    "PRE": "Pre",
    "PICTURE": "Picture",
    "PARAM": "Param",
    "P": "P",
    "OUTPUT": "Output",
    "OPTION": "Option",
    "OPTGROUP": "Optgroup",
    "OBJECT": "Object",
    "OL": "OL",
    "INS": "Ins",
    "DEL": "Del",
    "METER": "Meter",
    "META": "Meta",
    "MENU": "Menu",
    "MAP": "Map",
    "LINK": "Link",
    "LEGEND": "Legend",
    "LABEL": "Label",
    "LI": "LI",
    "KEYGEN": "KeyGen",
    "INPUT": "Input",
    "IMAGE": "Image",
    "IFRAME": "IFrame",
    "H1": "H1",
    "H2": "H2",
    "H3": "H3",
    "H4": "H4",
    "H5": "H5",
    "H6": "H6",
    "HR": "Hr",
    "FRAMESET": "FrameSet",
    "FRAME": "Frame",
    "FORM": "Form",
    "FONT": "Font",
    "EMBED": "Embed",
    "ARTICLE": "Article",
    "ASIDE": "Aside",
    "FOOTER": "Footer",
    "FIGURE": "Figure",
    "FIGCAPTION": "FigCaption",
    "HEADER": "Header",
    "MAIN": "Main",
    "MARK": "Mark",
    "MENUITEM": "MenuItem",
    "NAV": "Nav",
    "SECTION": "Section",
    "SUMMARY": "Summary",
    "WBR": "WBr",
    "DIV": "Div",
    "DIALOG": "Dialog",
    "DETAILS": "Details",
    "DATALIST": "DataList",
    "DL": "DL",
    "CANVAS": "Canvas",
    "BUTTON": "Button",
    "BASE": "Base",
    "BR": "Br",
    "AREA": "Area",
    "A": "A"
};


//////////////////
// WEBPACK FOOTER
// ./src/tags.js
// module id = 3
// module chunks = 0